exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-control{\r\n  width: 100%;\r\n  background-color: #f5f5f5;\r\n}\r\n\r\n.white{\r\n  background-color: white;\r\n}\r\n\r\n\r\ntextarea{\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.text-area{\r\n  margin-right: 0px;\r\n  width: 100%;\r\n  max-width: 100%;\r\n  height: 150px;\r\n}\r\n\r\n.control-label{\r\n  padding-top: 10px;\r\n  height: 34px;\r\n}\r\n\r\n.radio-label{\r\n  padding-top: 0px;\r\n}\r\n\r\n.radioDiv{\r\n  width: 301px;\r\n  height: 44px;\r\n  padding-left: 15px;\r\n  padding-right: 15px;\r\n}\r\n\r\n.twoSize{\r\n  float: right;\r\n  padding-right: 17px;\r\n}\r\n\r\nh4{\r\n  font-size: 24px;\r\n}\r\n\r\n.modal-body{\r\n  height: 100%;\r\n}\r\n\r\n.buttonStyling {\r\n  background-color: #fff;\r\n  border-style: none;\r\n  padding-right: 0px;\r\n  padding-left: 0px;\r\n  margin-right: 5px\r\n}\r\n\r\n.labelForButton {\r\n  color:#fff;\r\n  background-color:#5cb85c;\r\n  border-color:#4cae4c;\r\n}\r\n\r\n.backgroundForButton {\r\n  background-color:#5cb85c;\r\n  border-color:#4cae4c;\r\n}\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Projects/ePlanner Maintenance/src/app/controllers/task-administration/CreateTaskModal/CreateTaskModal.component.css
// module id = ../../../../../src/app/controllers/task-administration/CreateTaskModal/CreateTaskModal.component.css
// module chunks = main